import { createPromiseAction } from '@adobe/redux-saga-promise';
import { SET_PERMISSIONS, CLEAR_PERMISSIONS, REFRESH_PERMISSIONS } from './actionTypes';

export const setPermissions = (role, type) => ({
    type: SET_PERMISSIONS, payload: { role, type },
});
export const clearPermissions = () => ({ type: CLEAR_PERMISSIONS });

export const refreshPermissions = createPromiseAction(REFRESH_PERMISSIONS);
